// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 779 ? "48a2b6db" : chunkId) + "." + {"229":"70e908f3498dc21a","284":"9ac071f43b7ea4b8","779":"6b8323eb975d96a3"}[chunkId] + ".js";
};